/**
 * 部标机异常表格列配置
 */
import React from "react";
import RenderEllipsisColumn from "@/components/renderEllipsisColumn";
import { formatTime } from "@/utils/formatTime";
import { renderDifferentTableCell } from "@/utils/common";
import { DeviceTypeEnum } from "@/constants/deviceManage";

// 渲染表格列内容
const renderColumnText = (value: number) => (value ? "是" : "否");

// 部标机异常表格列
export const getJtDeviceErrorColumns = (allData: any, deviceType?: number) => {

  // console.log('deviceType', deviceType);
  // debugger

  const _renderMapper = (item: any) => {
    const returnItem = { ...item };
    const { noCommonRender, noCommonCell, dataIndex } = item;
    if (!noCommonRender) {
      returnItem.render = (value: any) => renderColumnText(value);
    }
    if (!noCommonCell) {
      returnItem.onCell = (record: any, rowIndex: number) =>
        renderDifferentTableCell(record, rowIndex, dataIndex, allData);
    }
    returnItem.key = dataIndex;
    return returnItem;
  }
  
  const _deviceType = deviceType || -1;
  const _deviceTypeFilter = (item: any) => {
    //没有flag说明是常显列
    if (!item.deviceTypeFlag) {
      return true;
    }
    //添加一个设备类型判断，兼容两种骏驰的设备类型，TLY5C1也显示骏驰的列
    if (item.deviceType === DeviceTypeEnum.junchi1 && (_deviceType === DeviceTypeEnum.junchi1 || _deviceType === DeviceTypeEnum.TLY5C1)) {
      return true;
    }
    return item.deviceType === _deviceType;
  };

  const columns = [
    {
      key: "reportedAt",
      title: "上报时间",
      dataIndex: "reportedAt",
      width: 80,
      render: (value: any) => (
        <RenderEllipsisColumn text={formatTime(value)} ellipsis />
      ),
      fixed: "left" as const,
      noCommonRender: true,
      noCommonCell: true,
    },
    {
      key: "gnssError",
      title: "gnss模块故障",
      dataIndex: "gnssError",
      width: 60,
    },
    {
      key: "gnssConnectionFailure",
      title: "gnss天线未接或被剪断",
      dataIndex: "gnssConnectionFailure",
      width: 70,
    },
    {
      key: "gnssShortCircuit",
      title: "gnss天线短路",
      dataIndex: "gnssShortCircuit",
      width: 60,
    },
    {
      key: "powerUndervoltage",
      title: "终端主电源欠压",
      dataIndex: "powerUndervoltage",
      width: 60,
    },
    {
      key: "powerDown",
      title: "终端主电源掉电",
      dataIndex: "powerDown",
      width: 60,
    },
    {
      key: "lcdError",
      title: "终端LCD或显示器故障",
      dataIndex: "lcdError",
      width: 70,
    },
    {
      key: "ttsError",
      title: "TTS模块故障",
      dataIndex: "ttsError",
      width: 60,
    },
    {
      key: "cameraError",
      title: "摄像头故障",
      dataIndex: "cameraError",
      width: 60,
    },
    {
      key: "icError",
      title: "道路运输证IC卡模块故障",
      dataIndex: "icError",
      width: 80,
    },
    {
      key: "vehicleVssError",
      title: "车辆VSS故障",
      dataIndex: "vehicleVssError",
      width: 60,
    },
    {
      key: "vehicleOilError",
      title: "车辆油量异常",
      dataIndex: "vehicleOilError",
      width: 60,
    },
    {
      key: "vehicleTheft",
      title: "车辆被盗",
      dataIndex: "vehicleTheft",
      width: 60,
    },
    {
      key: "vehicleLaunchIllegally",
      title: "车辆非法点火",
      dataIndex: "vehicleLaunchIllegally",
      width: 70,
    },
    {
      key: "vehicleMoveIllegally",
      title: "车辆非法位移",
      dataIndex: "vehicleMoveIllegally",
      width: 70,
    },
    {
      key: "cameraSignalLoss1",
      title: "通道1相机信号丢失",
      dataIndex: "cameraSignalLoss1",
      width: 70,
    },
    {
      key: "cameraSignalLoss2",
      title: "通道2相机信号丢失",
      dataIndex: "cameraSignalLoss2",
      width: 70,
    },
    {
      key: "cameraSignalLoss3",
      title: "通道3相机信号丢失",
      dataIndex: "cameraSignalLoss3",
      width: 70,
    },
    {
      key: "cameraSignalLoss4",
      title: "通道4相机信号丢失",
      dataIndex: "cameraSignalLoss4",
      width: 70,
    },
    {
      key: "cameraSignalLoss5",
      title: "通道5相机信号丢失",
      dataIndex: "cameraSignalLoss5",
      width: 70,
    },
    {
      key: "cameraMask1",
      title: "通道1相机遮挡",
      dataIndex: "cameraMask1",
      width: 60,
    },
    {
      key: "cameraMask2",
      title: "通道2相机遮挡",
      dataIndex: "cameraMask2",
      width: 60,
    },
    {
      key: "cameraMask3",
      title: "通道3相机遮挡",
      dataIndex: "cameraMask3",
      width: 60,
    },
    {
      key: "cameraMask4",
      title: "通道4相机遮挡",
      dataIndex: "cameraMask4",
      width: 60,
    },
    {
      key: "cameraMask5",
      title: "通道5相机遮挡",
      dataIndex: "cameraMask5",
      width: 60,
    },
    {
      key: "memoryFailure",
      title: "存储单元故障",
      dataIndex: "memoryFailure",
      width: 60,
    },
    {
      title: "CANBUS接线",
      dataIndex: "canBusWiring",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.junchi1,
    },
    {
      title: "CANBUS车速解析",
      dataIndex: "canBusSpeedAnalysis",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.junchi1,
    },
    {
      title: "定位速度与总线车速故障",
      dataIndex: "carSpeedStatus",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.junchi1,
    },
    {
      title: "执行机构故障",
      dataIndex: "executingAgencyStatus",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.junchi1,
    },
    {
      title: "SD卡故障",
      dataIndex: "sdCardStatus",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.junchi1,
    },
    {
      title: "SIM卡故障",
      dataIndex: "simCardStatus",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.junchi1,
    },
    {
      title: "惯导模块故障",
      dataIndex: "inertialGuidanceModuleStatus",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.junchi1,
    },
    {
      title: "定位模块故障",
      dataIndex: "positioningModuleStatus",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.junchi1,
    },
    {
      title: "前盲雷达故障",
      dataIndex: "frontBlindRadarStatus",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.junchi1,
    },
    {
      title: "右盲雷达故障",
      dataIndex: "rightBlindRadarStatus",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.junchi1,
    },
    {
      title: "左盲雷达故障",
      dataIndex: "leftBlindRadarStatus",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.junchi1,
    },
    {
      title: "后盲雷达故障",
      dataIndex: "rearBlindRadarStatus",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.junchi1,
    },
    {
      title: "前向雷达故障",
      dataIndex: "forwardFacingRadarStatus",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.junchi1,
    },
    {
      title: "前盲摄像头故障",
      dataIndex: "frontBlindCameraStatus",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.junchi1,
    },
    {
      title: "右盲摄像头故障",
      dataIndex: "rightBlindCameraStatus",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.junchi1,
    },
    {
      title: "左盲摄像头故障",
      dataIndex: "leftBlindCameraStatus",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.junchi1,
    },
    {
      title: "后盲摄像头故障",
      dataIndex: "rearBlindCameraStatus",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.junchi1,
    },
    {
      title: "前向摄像头故障",
      dataIndex: "forwardFacingCameraStatus",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.junchi1,
    },
    {
      title: "盲区制动主动屏蔽(人为)",
      dataIndex: "blindBrakeManShieldStatus",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.junchi1,
    },
    {
      title: "前向制动主动屏蔽(人为)",
      dataIndex: "forwardBrakeManShieldStatus",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.junchi1,
    },
    {
      title: "盲区制动平台屏蔽",
      dataIndex: "blindBrakePlatformShieldStatus",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.junchi1,
    },
    {
      title: "前向制动平台屏蔽",
      dataIndex: "forwardBrakePlatformShieldStatus",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.junchi1,
    },
    {
      title: " 系统自检",
      dataIndex: "systemSelfTest",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.junchi1,
    },
    {
      title: "车速获取异常",
      dataIndex: "vehicleSpeedErr",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.jimu,
    },
    {
      title: "刹车灯故障",
      dataIndex: "signalBreakErr",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.jimu,
    },
    {
      title: "左转灯故障",
      dataIndex: "signalLeftErr",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.jimu,
    },
    {
      title: "右转灯故障",
      dataIndex: "signalRightErr",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.jimu,
    },
    {
      title: "CAN0总线故障",
      dataIndex: "can0Err",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.jimu,
    },
    {
      title: "CAN1总线故障",
      dataIndex: "can1Err",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.jimu,
    },
    {
      title: "ADAS相机故障",
      dataIndex: "aebCameraErr",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.jimu,
    },
    {
      title: "DMS相机故障",
      dataIndex: "dmsCameraErr",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.jimu,
    },
    {
      title: "BSD右前相机故障",
      dataIndex: "bsd1CameraErr",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.jimu,
    },
    {
      title: "BSD右后相机故障",
      dataIndex: "bsd2CameraErr",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.jimu,
    },
    {
      title: "BSD后相机故障",
      dataIndex: "bsd3CameraErr",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.jimu,
    },
    {
      title: "前向毫米雷达波故障",
      dataIndex: "radarErr",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.jimu,
    },
    {
      title: "GPS设备故障",
      dataIndex: "gpsErr",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.jimu,
    },
    {
      title: "拉线电机故障",
      dataIndex: "cableMotorErr",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.jimu,
    },
    {
      title: "小屏故障",
      dataIndex: "screenErr",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.jimu,
    },
    {
      title: "4G设备故障",
      dataIndex: "t4gErr",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.jimu,
    },
    {
      title: "AEB功能",
      dataIndex: "aebErr",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.jimu,
      noCommonRender: true,
      render: (value: number) => {
        const map: Record<number, string> = { 0: '关闭', 1: '打开', 2: '故障' };
        return map[value] ?? value;
      },
    },
    {
      title: "7寸屏故障",
      dataIndex: "screen7Err",
      width: 70,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.jimu,
    },
  ];

  return columns.filter(_deviceTypeFilter).map(_renderMapper);
};
export const getVersionChangeColumnsV1 = (allData: any) => {
  return [
    {
      key: 'reportedTime',
      title: '上报时间',
      dataIndex: 'reportedTime',
      render: (value: any) => (
        <RenderEllipsisColumn text={formatTime(value)} ellipsis />
      ),
      fixed: 'left' as const,
      noCommonRender: true,
      noCommonCell: true
    },
    {
      key: 'createdAt',
      title: '创建时间',
      dataIndex: 'createdAt',
      render: (value: any) => (
        <RenderEllipsisColumn text={formatTime(value)} ellipsis />
      ),
      noCommonRender: true,
      noCommonCell: true
    },
    {
      key: 'hwVersion',
      title: '硬件版本',
      dataIndex: 'hwVersion',
      noCommonRender: true,
    },
    {
      key: 'swVersion',
      title: '软件版本',
      dataIndex: 'swVersion',
      noCommonRender: true,
    },
  ].map((item: any) => {
    const returnItem = { ...item };
    const { noCommonRender, noCommonCell, dataIndex } = item;
    if (!noCommonRender) {
      returnItem.render = (value: any) => renderColumnText(value);
    }
    if (!noCommonCell) {
      returnItem.onCell = (record: any, rowIndex: number) =>
        renderDifferentTableCell(record, rowIndex, dataIndex, allData);
    }
    returnItem.key = dataIndex
    return returnItem;
  });
};
export const getDeviceParamsChangeColumns = (allData: any, deviceType?: number) => {
  const _renderMapper = (item: any) => {
    const returnItem = { ...item };
    const { noCommonRender, noCommonCell, dataIndex } = item;
    if (!noCommonRender) {
      returnItem.render = (value: any) => renderColumnText(value);
    }
    if (!noCommonCell) {
      returnItem.onCell = (record: any, rowIndex: number) =>
        renderDifferentTableCell(record, rowIndex, dataIndex, allData);
    }
    returnItem.key = dataIndex;
    return returnItem;
  }
  const _deviceType = deviceType || -1;
  const _deviceTypeFilter = (item: any) => {
    //没有flag说明是常显列
    if (!item.deviceTypeFlag) {
      return true;
    }
    if (
      item.deviceType === DeviceTypeEnum.junchi1 &&
      (_deviceType === DeviceTypeEnum.junchi1 ||
        _deviceType === DeviceTypeEnum.TLY5C1)
    ) {
      return true;
    }
    return item.deviceType === _deviceType;
  };

  const col = [
    {
      key: "reportedTime",
      title: "上报时间",
      dataIndex: "reportedTime",
      render: (value: any) => (
        <RenderEllipsisColumn text={formatTime(value)} ellipsis />
      ),
      fixed: "left" as const,
      noCommonRender: true,
      noCommonCell: true,
    },
    {
      key: "createdAt",
      title: "创建时间",
      dataIndex: "createdAt",
      render: (value: any) => (
        <RenderEllipsisColumn text={formatTime(value)} ellipsis />
      ),
      noCommonRender: true,
      noCommonCell: true,
    },
    {
      key: "brakeMode",
      title: "刹车模式",
      dataIndex: "brakeMode",
      noCommonRender: true,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.junchi1,
    },
    {
      key: "brakeLevel",
      title: "刹车等级",
      dataIndex: "brakeLevel",
      noCommonRender: true,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.junchi1,
    },
    {
      key: "brakeSensitivityLevel",
      title: "刹车灵敏度等级",
      dataIndex: "brakeSensitivityLevel",
      noCommonRender: true,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.junchi1,
    },
    {
      key: "alarmVolume",
      title: "报警音量",
      dataIndex: "alarmVolume",
      noCommonRender: true,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.junchi1,
    },
    {
      key: "vehTurnLightAcquisitionMethod",
      title: "转向策略",
      dataIndex: "vehTurnLightAcquisitionMethod",
      noCommonRender: true,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.jimu,
    },
    {
      key: "vehSpeedAcquisitionMethod",
      title: "速度策略",
      dataIndex: "vehSpeedAcquisitionMethod",
      noCommonRender: true,
      deviceTypeFlag: true,
      deviceType: DeviceTypeEnum.jimu,
    },
  ]

  return col.filter(_deviceTypeFilter).map(_renderMapper)

};
